//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { userInfo, searchVipBar } from './components'
export default {
  name: 'RecommendPage',
  extends: vComponent,
  components: { userInfo, searchVipBar },
  data () {
    return {
      items: [], // 取得的資料
      meta: {},
      columns: [ // 欄位宣告
        { name: 'PLU_CODE', label: '商品編號', field: 'PLU_CODE' },
        { name: 'BARCODE', label: '條碼', field: 'BARCODE' },
        { name: 'PC_NAME', label: '商品名稱', field: 'PC_NAME' },
        { name: 'CO_PRICE', label: '原價', field: 'CO_PRICE' },
        { name: 'S_PRICE', label: '特價', field: 'S_PRICE' },
        { name: 'MEMO', label: '備註', field: 'MEMO' },
        { name: 'IMAGEPATH', label: '圖檔路徑', field: 'IMAGEPATH' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 20 // 0 means all rows
      }
    }
  },
  async created () {
    await this.defaultQuery()
  },
  methods: {
    async defaultQuery () {
      const response = await this.fetch('recommend', this.params.vipcode)
      this.items = response.data !== null ? response.data : []
      console.log(`this.items=`)
      console.log(this.items)
    }
  }
}
